import axios from '@/api/tool'

/**
 * 获取企业信息
 */
export function commonGetCompanyInfo() {
  return axios({
    url: '/common/getCompanyInfo',
    method: 'get'
  })
}
/*提交生成申请*/
export function commonSubmitGenerateApproval(data) {
  return axios({
    url: '/common/approval/submit',
    method: 'post',
    data: data
  })
}
